<template>
  <div style="z-index: 9999;" class="my-chart-container">
    <beautiful-chat
      :participants="participants"
      :titleImageUrl="titleImageUrl"
      :onMessageWasSent="onMessageWasSent"
      :messageList="messageList"
      :newMessagesCount="newMessagesCount"
      :isOpen="isChatOpen"
      :close="closeChat"
      :icons="icons"
      :open="openChat"
      :showEmoji="false"
      :showFile="false"
      :showEdition="true"
      :showDeletion="true"
      :showTypingIndicator="showTypingIndicator"
      :showLauncher="true"
      :showCloseButton="true"
      :colors="colors"
      :alwaysScrollToBottom="alwaysScrollToBottom"
      :messageStyling="messageStyling"
      placeholder="请输入想要询问的内容..."
      @onType="handleOnType"
      @edit="editMessage">
      <template v-slot:header>
        <div style="text-align: center; line-height: 55px;">
          <img :src="titleImg" height="40px" style="display: inline-block; vertical-align: middle;"/>
        </div>
        <span style="line-height: 55px; margin-left: 10px; font-size: 18px;">鼎函科技智能客服</span>
        <div class="sc-header--close-button" style="margin-left: auto;" @click="retractChat">
          <div style="width: 45%; height: 0.5px; box-sizing: border-box;background-color: #FFF; margin-top: 19.5px; margin-left: 10px;"></div>
        </div>
      </template>
      <template v-slot:user-avatar>
        <div></div>
      </template>
      <template v-slot:text-message-body="{ message }">
        <div v-if="message.author == 'dingHan'" style="position: relative; top: -26px; left: -20px; height: 0px; color: rgb(34, 34, 34); float: left;">
          <span style="position: absolute; width: 90px;">小鼎&nbsp;&nbsp;{{message.data.sendTime}}</span>
        </div>
        <div v-else style="position: relative; top: -26px; right: 40px; height: 0px; color: rgb(34, 34, 34); float: right;">
          <span style="position: absolute; width: 90px;">{{message.data.sendTime}}&nbsp;&nbsp;我</span>
        </div>
        <div>{{message.data.text}}</div>
        <div v-if="message.data.clickableText != null" style="margin-top: 5px;">
          <div v-for="(item, index) in message.data.clickableText" :key="'message' + index">
            <div style="color: #4395ff; cursor: pointer; padding-left: 8px;" @click="problemMessage(item.code, item.name)">
              <span v-if="item.type == 'back'">{{item.name}}</span>
              <span v-else>{{(index+1) + '.' + item.name}}</span>
            </div>
          </div>
        </div>
      </template>
    </beautiful-chat>
  </div>
</template>
<script>
import Chat from 'vue-beautiful-chat';
import Vue from 'vue';
Vue.use(Chat);
import titleImg from '@/assets/chatWindow/title.png';
import help from '@/assets/chatWindow/help.jpg';

export default {
  data() {
    return {
      titleImg: titleImg,
      help: help,
      icons:{
        open:{
          img: help,
          name: 'open',
        },
        close:{
          img: help,
          name: 'default',
        },
      },
      participants: [
        {
          id: 'dingHan',
          name: 'dingHan'
        }
      ], // the list of all the participant of the conversation. 'name' is the user name, 'id' is used to establish the author of a message, 'imageUrl' is supposed to be the user avatar.
      titleImageUrl: '/src/assets/chatWindow/title.png',
      messageList: [
          {
            type: 'text',
            author: 'dingHan',
            data: {
              text: '您好，欢迎来到鼎函电子保险（保函）平台，我是智能客服小鼎，有什么可以帮到您？如需人工客服请拨打400-6399580或13948539227',
              sendTime: this.getDate()
            }
          },
          {
            type: 'text',
            author: 'dingHan',
            data: {
              text: '热门提问',
              clickableText: [
                {code: 'toubao_1', name: '如何进行投保'},
                {code: 'toubao_12', name: '投保前需要准备哪些资料'},
                {code: 'toubao_10', name: '投保失败是什么原因'},
                {code: 'tuibao_1', name: '买了保证保险，可以退保吗'}
              ],
              sendTime: this.getDate()
            }
          },
          {
            type: 'text',
            author: 'dingHan',
            data: {
              text: '其他提问',
              clickableText: [
                {code: 'toubao', name: '投保相关'},
                {code: 'tuibao', name: '退保相关'},
                {code: 'lipei', name: '理赔相关'},
                {code: 'yemian', name: '页面相关'}
              ],
              sendTime: this.getDate()
            }
          },
      ], // the list of the messages to show, can be paginated and adjusted dynamically
      newMessagesCount: 0,
      isChatOpen: false, // to determine whether the chat window should be open or closed
      showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: '#2439a2',
          text: '#ffffff'
        },
        launcher: {
          bg: '#2439a2'
        },
        messageList: {
          bg: '#ffffff'
        },
        sentMessage: {
          bg: '#4e8cff',
          text: '#ffffff'
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222'
        },
        userInput: {
          bg: '#f4f7f9',
          text: '#565867'
        }
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: true, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: true, // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
      problemMap: {
        'all': {
          text: '其他提问：',
          clickableText: [
            {code: 'toubao', name: '投保相关'},
            {code: 'tuibao', name: '退保相关'},
            {code: 'lipei', name: '理赔相关'},
            {code: 'yemian', name: '页面相关'}
          ]
        },
        'toubao': {
          text: '投保相关提问：',
          clickableText: [
            {code: 'toubao_1', name: '如何进行投保'},
            {code: 'toubao_2', name: '保证保险中，投保人含义是什么'},
            {code: 'toubao_3', name: '保证保险中，投保含义是什么'},
            {code: 'toubao_5', name: '保证保险中，保险人含义是什么'},
            {code: 'toubao_6', name: '保证保险中，被保险人含义是什么'},
            {code: 'toubao_8', name: '到开标日期未缴款会怎样'},
            {code: 'toubao_10', name: '投保失败是什么原因'},
            {code: 'toubao_11', name: '如何进行投保'},
            {code: 'toubao_12', name: '投保前需要准备哪些资料'},
            {code: 'toubao_13', name: '投标保证保险的行业意义'},
            {code: 'toubao_14', name: '开标当日是否可以进行投保'},
            {code: 'all', name: '其他提问', type: 'back'}
          ]
        },
        'tuibao': {
          text: '退保相关提问：',
          clickableText: [
            {code: 'tuibao_1', name: '买了保证保险，可以退保吗'},
            {code: 'tuibao_2', name: '保证保险中，退保含义是什么'},
            {code: 'tuibao_3', name: '什么情况下不可以进行退保'},
            {code: 'tuibao_4', name: '保证保险退保后款项退到哪里'},
            {code: 'all', name: '其他提问', type: 'back'}
          ]
        },
        'lipei': {
          text: '理赔相关提问：',
          clickableText: [
            {code: 'lipei_1', name: '保证保险如何理赔'},
            {code: 'lipei_2', name: '保证保险理赔没有到账怎么办'},
            {code: 'all', name: '其他提问', type: 'back'}
          ]
        },
        'yemian': {
          text: '页面相关提问：',
          clickableText: [
            {code: 'yemian_1', name: '用户密码如何修改'},
            {code: 'yemian_3', name: '客服电话是多少'},
            {code: 'all', name: '其他提问', type: 'back'}
          ]
        },
        'toubao_1': {
          text: '进入鼎函电子保险（保函）平台（投保企业端）后，点击上方的立即投保按钮，选择对应的地区进行投保。', clickableText: [{code: 'toubao', name: '继续提问', type: 'back'}]
        },
        'toubao_2': {
          text: '保证保险中，投保人是与保险人订立保险合同，并按照保险合同负有支付保险费义务的人。', clickableText: [{code: 'toubao', name: '继续提问', type: 'back'}]
        },
        'toubao_3': {
          text: '保证保险中，投保是对财产、人身、责任及权益等具有保险利益的自然人或法人，通过购买保险与保险人建立保险合同关系的行为。', clickableText: [{code: 'toubao', name: '继续提问', type: 'back'}]
        },
        'toubao_4': {
          text: '暂无相关解答', clickableText: [{code: 'toubao', name: '继续提问', type: 'back'}]
        },
        'toubao_5': {
          text: '保证保险中，保险人是与投保人订立保险合同，并承担赔偿或者给付保险金责任的保险公司。', clickableText: [{code: 'toubao', name: '继续提问', type: 'back'}]
        },
        'toubao_6': {
          text: '保证保险中，被保险人是其财产或者人身受保险合同保障，享有保险金请求权的人。', clickableText: [{code: 'toubao', name: '继续提问', type: 'back'}]
        },
        'toubao_7': {
          text: '暂无相关解答', clickableText: [{code: 'toubao', name: '继续提问', type: 'back'}]
        },
        'toubao_8': {
          text: '投保单在项目开标日期仍未缴费，该投保单将被关闭，不再允许进行缴费操作；如仍需出函，则需您重新进行投保；', clickableText: [{code: 'toubao', name: '继续提问', type: 'back'}]
        },
        'toubao_9': {
          text: '保单均为电子保单，请您查看投保时填写的邮箱中是否有相关邮件（或被当做垃圾邮件拦截）；如核实后仍未查到保单，还请您联系保险公司咨询。', clickableText: [{code: 'toubao', name: '继续提问', type: 'back'}]
        },
        'toubao_10': {
          text: '若投保失败，请核实您的信息是否填写正确。若信息填写正确后仍有异常，建议您联系对应保险公司进行核实。', clickableText: [{code: 'toubao', name: '继续提问', type: 'back'}]
        },
        'toubao_11': {
          text: '进入鼎函电子保险（保函）平台（投保企业端）后，点击上方的立即投保按钮，选择对应的地区进行投保', clickableText: [{code: 'toubao', name: '继续提问', type: 'back'}]
        },
        'toubao_12': {
          text: '投保前需要在鼎函电子保险（保函）平台（投保企业端）个人中心中完善填写公司信息后进行投保', clickableText: [{code: 'toubao', name: '继续提问', type: 'back'}]
        },
        'toubao_13': {
          text: '工程投标保证保险，指保险公司向工程项目招标人提供的保证工程项目投标人履行投标义务的保险。一旦投标人未履行投标义务导致招标人产生损失时，保险公司向招标人承担代偿责任。', clickableText: [{code: 'toubao', name: '继续提问', type: 'back'}]
        },
        'toubao_14': {
          text: '开标当日可以进行投保，但需注意以下内容：1.起保日期为开标日期+1天，如因保单起期未覆盖到开标当天而不具备投标资格，后果由投标人自行承担。2.由于该投保单起保日期为开标日期+1日的0时，故在投保当日23:00之前必须完成该投保单的保费缴纳，超时未缴费，该投保单将被关闭，不再允许进行缴费操作；', clickableText: [{code: 'toubao', name: '继续提问', type: 'back'}]
        },
        'tuibao_1': {
          text: '可以，保险保函属于消费型险种，没开标之前可以申请退保，一旦开标后，就不能退了。', clickableText: [{code: 'tuibao', name: '继续提问', type: 'back'}]
        },
        'tuibao_2': {
          text: '保险合同双方当事人中的任何一方中途通知对方要求终止保险合同的行为。', clickableText: [{code: 'tuibao', name: '继续提问', type: 'back'}]
        },
        'tuibao_3': {
          text: '遇到以下情况投标保证金可以不予退还: 一、投标截止后投标人撤销投标文件； 二、中标通知书发出后，中标人放弃中标项目； 三、中标人无正当理由不与招标人订立合同； 四、中标人在签订合同时向招标人提出附加条件； 五、中标人不按照招标文件要求提交履约保证金；', clickableText: [{code: 'tuibao', name: '继续提问', type: 'back'}]
        },
        'tuibao_4': {
          text: '款项会根据用户投保付款时的银行账号原路返回', clickableText: [{code: 'tuibao', name: '继续提问', type: 'back'}]
        },
        'tuibao_5': {
          text: '暂无相关解答', clickableText: [{code: 'tuibao', name: '继续提问', type: 'back'}]
        },
        'lipei_1': {
          text: '若需申请保证保险理赔，请联系客服人员进行理赔', clickableText: [{code: 'lipei', name: '继续提问', type: 'back'}]
        },
        'lipei_2': {
          text: '若保证保险理赔后没有到账，建议您联系客服人员进行处理', clickableText: [{code: 'lipei', name: '继续提问', type: 'back'}]
        },
        'lipei_3': {
          text: '暂无相关解答', clickableText: [{code: 'lipei', name: '继续提问', type: 'back'}]
        },
        'lipei_4': {
          text: '暂无相关解答', clickableText: [{code: 'lipei', name: '继续提问', type: 'back'}]
        },
        'yemian_1': {
          text: '登录鼎函电子保险（保函）平台（投保企业端）后，点击页面上方的修改密码或在左侧状态栏中的修改密码', clickableText: [{code: 'yemian', name: '继续提问', type: 'back'}]
        },
        'yemian_2': {
          text: '可以通过客服电话：400-6399580 、13948539227进行联系', clickableText: [{code: 'yemian', name: '继续提问', type: 'back'}]
        },
        'yemian_3': {
          text: '客服电话：400-6399580 、13948539227', clickableText: [{code: 'yemian', name: '继续提问', type: 'back'}]
        }
      }
    }
  },
  props: {},
  watch: {},
  mounted() {},
  methods: {
    getDate() {
        var date = new Date();
        this.year = date.getFullYear();
        this.month = date.getMonth() + 1;
        this.date = date.getDate();
        this.day = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六")[date.getDay()];
        this.hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        this.minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        this.second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        // var currentTime = this.year + "-" + this.month + "-" + this.date + " "
        // +this.hour+":"+this.minute+":"+this.second;
        var currentTime = this.hour+":"+this.minute;
        return currentTime;
    },
    problemMessage(code, name){
      this.messageList = [ ...this.messageList, { author: 'me', type: 'text', data: { text: name, sendTime: this.getDate()}}];
      let messageData = this.problemMap[code];
      if(messageData == null){
        messageData = {text: '暂无相关解答'};
      }
      messageData.sendTime = this.getDate();
      this.onMessageWasSentSystem({
        type: 'text',
        author: 'dingHan',
        data: messageData
      });


      // switch(code){
      //   case 'toubao':
      //     this.onMessageWasSentSystem({
      //       type: 'text',
      //       author: 'dingHan',
      //       data: {
      //         text: '投保相关提问：',
      //         clickableText: [
      //           {code: 'toubao_1', name: '1.如何进行投保'},
      //           {code: 'toubao_2', name: '2.保证保险中，投保人含义是什么'},
      //           {code: 'toubao_3', name: '3.保证保险中，投保含义是什么'},
      //           {code: 'toubao_4', name: '4.保证型保单怎么查看'},
      //           {code: 'toubao_5', name: '5.保证保险中，保险人含义是什么'},
      //           {code: 'toubao_6', name: '6.保证保险中，被保险人含义是什么'},
      //           {code: 'toubao_7', name: '7.为什么无法购买保证保险'},
      //           {code: 'toubao_8', name: '8.保险逾期未缴款会怎样'},
      //           {code: 'toubao_9', name: '9.保证保险没收到保单怎么办'},
      //           {code: 'toubao_10', name: '10.投保失败是什么原因'},
      //           {code: 'toubao_11', name: '11.如何进行投保'},
      //           {code: 'toubao_12', name: '12.投保前需要准备哪些资料'},
      //           {code: 'toubao_13', name: '13.投标保证保险的行业意义'},
      //           {code: 'all', name: '其他提问'}
      //         ],
      //         sendTime: this.getDate()
      //       }
      //     });
      //     break;
      //   case 'tuibao':
      //     this.onMessageWasSentSystem({
      //       type: 'text',
      //       author: 'dingHan',
      //       data: {
      //         text: '退保相关提问：',
      //         clickableText: [
      //           {code: 'tuibao_1', name: '1.买了保证保险，可以退保吗'},
      //           {code: 'tuibao_2', name: '2.保证保险中，退保含义是什么'},
      //           {code: 'tuibao_3', name: '3.什么情况下不可以进行退保'},
      //           {code: 'tuibao_4', name: '4.保证保险退保后款项退到哪里'},
      //           {code: 'tuibao_5', name: '5.退保时间一般多久'},
      //           {code: 'all', name: '其他提问'}
      //         ],
      //         sendTime: this.getDate()
      //       }
      //     });
      //     break;
      //   case 'lipei':
      //     this.onMessageWasSentSystem({
      //       type: 'text',
      //       author: 'dingHan',
      //       data: {
      //         text: '理赔相关提问：',
      //         clickableText: [
      //           {code: 'lipei_1', name: '1.保证保险如何理赔'},
      //           {code: 'lipei_2', name: '2.保证保险理赔没有到账怎么办'},
      //           {code: 'lipei_3', name: '3.保险的理赔速度一般多久算正常'},
      //           {code: 'lipei_4', name: '4.一般什么情况下保险公司会拒赔'},
      //           {code: 'all', name: '其他提问'}
      //         ],
      //         sendTime: this.getDate()
      //       }
      //     });
      //     break;
      //   case 'yemian':
      //     this.onMessageWasSentSystem({
      //       type: 'text',
      //       author: 'dingHan',
      //       data: {
      //         text: '页面相关提问：',
      //         clickableText: [
      //           {code: 'yemian_1', name: '1.用户密码如何修改'},
      //           {code: 'yemian_2', name: '2.如何联系客服人员'},
      //           {code: 'yemian_3', name: '3.客服电话是多少'},
      //           {code: 'all', name: '其他提问'}
      //         ],
      //         sendTime: this.getDate()
      //       }
      //     });
      //     break;
      //   case 'all':
      //     this.onMessageWasSentSystem({
      //       type: 'text',
      //       author: 'dingHan',
      //       data: {
      //         text: '其他提问：',
      //         clickableText: [
      //           {code: 'toubao', name: '1.投保相关'},
      //           {code: 'tuibao', name: '2.退保相关'},
      //           {code: 'lipei', name: '3.理赔相关'},
      //           {code: 'yemian', name: '4.页面相关'}
      //         ],
      //         sendTime: this.getDate()
      //       }
      //     });
      //     break;
      //   case 'toubao_1':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '进入鼎函电子保险（保函）平台（投保企业端）后，点击上方的立即投保按钮，选择对应的地区进行投保。', clickableText: [{code: 'toubao', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'toubao_2':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '保证保险中，投保人是与保险人订立保险合同，并按照保险合同负有支付保险费义务的人。', clickableText: [{code: 'toubao', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'toubao_3':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '保证保险中，投保是对财产、人身、责任及权益等具有保险利益的自然人或法人，通过购买保险与保险人建立保险合同关系的行为。', clickableText: [{code: 'toubao', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'toubao_4':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '暂无相关解答', clickableText: [{code: 'toubao', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'toubao_5':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '保证保险中，保险人是与投保人订立保险合同，并承担赔偿或者给付保险金责任的保险公司。', clickableText: [{code: 'toubao', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'toubao_6':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '保证保险中，被保险人是其财产或者人身受保险合同保障，享有保险金请求权的人。', clickableText: [{code: 'toubao', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'toubao_7':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '暂无相关解答', clickableText: [{code: 'toubao', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'toubao_8':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '保险公司会给予60天的宽限期，60天内保障依旧生效，60天内缴清，就不会出现什么后果。 如果逾期60天还未缴款，保障则会无效。', clickableText: [{code: 'toubao', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'toubao_9':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '保单均为电子保单，请您查看投保时填写的邮箱中是否有相关邮件（或被当做垃圾邮件拦截）；如核实后仍未查到保单，还请您联系保险公司咨询。', clickableText: [{code: 'toubao', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'toubao_10':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '若投保失败，请核实您的信息是否填写正确。若信息填写正确后仍有异常，建议您联系对应保险公司进行核实。', clickableText: [{code: 'toubao', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'toubao_11':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '进入鼎函电子保险（保函）平台（投保企业端）后，点击上方的立即投保按钮，选择对应的地区进行投保', clickableText: [{code: 'toubao', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'toubao_12':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '投保前需要在鼎函电子保险（保函）平台（投保企业端）个人中心中完善填写公司信息后进行投保', clickableText: [{code: 'toubao', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'toubao_13':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '工程投标保证保险，指保险公司向工程项目招标人提供的保证工程项目投标人履行投标义务的保险。一旦投标人未履行投标义务导致招标人产生损失时，保险公司向招标人承担代偿责任。', clickableText: [{code: 'toubao', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'tuibao_1':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '可以，保险保函属于消费型险种，没开标之前可以申请退保，一旦开标后，就不能退了。', clickableText: [{code: 'tuibao', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'tuibao_2':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '保险合同双方当事人中的任何一方中途通知对方要求终止保险合同的行为。', clickableText: [{code: 'tuibao', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'tuibao_3':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '遇到以下情况投标保证金可以不予退还: 一、投标截止后投标人撤销投标文件； 二、中标通知书发出后，中标人放弃中标项目； 三、中标人无正当理由不与招标人订立合同； 四、中标人在签订合同时向招标人提出附加条件； 五、中标人不按照招标文件要求提交履约保证金；', clickableText: [{code: 'tuibao', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'tuibao_4':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '款项会根据用户投保付款时的银行账号原路返回', clickableText: [{code: 'tuibao', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'tuibao_5':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '暂无相关解答', clickableText: [{code: 'tuibao', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'lipei_1':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '若需申请保证保险理赔，请联系客服人员进行理赔', clickableText: [{code: 'lipei', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'lipei_2':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '若保证保险理赔后没有到账，建议您联系客服人员进行处理', clickableText: [{code: 'lipei', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'lipei_3':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '暂无相关解答', clickableText: [{code: 'lipei', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'lipei_4':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '暂无相关解答', clickableText: [{code: 'lipei', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'yemian_1':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '登录鼎函电子保险（保函）平台（投保企业端）后，点击页面上方的修改密码或在左侧状态栏中的修改密码', clickableText: [{code: 'yemian', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'yemian_2':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '可以通过客服电话：400-6399580 、13948539227进行联系', clickableText: [{code: 'yemian', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   case 'yemian_3':
      //     this.onMessageWasSentSystem({ type: 'text', author: 'dingHan', data: { text: '客服电话：400-6399580 、13948539227', clickableText: [{code: 'yemian', name: '继续提问'}], sendTime: this.getDate() } });
      //     break;
      //   default:
      //     this.onMessageWasSentSystem({
      //       type: 'text',
      //       author: 'dingHan',
      //       data: {
      //         text: '暂无相关解答',
      //         sendTime: this.getDate()
      //       }
      //     });
      // }
    },
    sendMessage (text) {
      if (text.length > 0) {
        this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
        this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
      }
    },
    onMessageWasSent (message) {
      // called when the user sends a message
      message.data.sendTime = this.getDate();
      this.messageList = [ ...this.messageList, message ]

      let text = '“' + message.data.text + '”相关提问内容如下。如需人工客服请拨打400-6399580或13948539227';
      let answerList = [];
      let keys = Object.keys(this.problemMap);
      for(let key of keys){
        let messageDatao = this.problemMap[key];
        if(messageDatao.clickableText != null){
          for(let i = 0; i < messageDatao.clickableText.length; i++){
            if(messageDatao.clickableText[i].name.indexOf(message.data.text) != -1){
              answerList.push(messageDatao.clickableText[i]);
            }
          }
        }
      }
      if(answerList.length <= 0){
        text = '您想咨询哪种类型呢？如需人工客服请拨打400-6399580或13948539227';
        answerList = [
          {code: 'toubao', name: '投保相关'},
          {code: 'tuibao', name: '退保相关'},
          {code: 'lipei', name: '理赔相关'},
          {code: 'yemian', name: '页面相关'}
        ];
      }

      this.messageList = [ ...this.messageList,
      {
        type: 'text',
        author: 'dingHan',
        data: {
          text: text,
          clickableText: answerList,
          sendTime: this.getDate()
        }
      }];


      // this.messageList = [ ...this.messageList,
      // {
      //   type: 'text',
      //   author: 'dingHan',
      //   data: {
      //     text: '您想咨询哪种类型呢？如需人工客服请拨打400-6399580或13948539227',
      //     clickableText: [
      //       {code: 'toubao', name: '1.投保相关'},
      //       {code: 'tuibao', name: '2.退保相关'},
      //       {code: 'lipei', name: '3.理赔相关'},
      //       {code: 'yemian', name: '4.页面相关'}
      //     ],
      //     sendTime: this.getDate()
      //   }
      // }];
    },
    onMessageWasSentSystem (message) {
      // called when the user sends a message
      message.data.sendTime = this.getDate();
      this.messageList = [ ...this.messageList, message ]
    },
    openChat () {
      // called when the user clicks on the fab button to open the chat
      this.isChatOpen = true
      this.newMessagesCount = 0
    },
    closeChat () {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false
      this.messageList.splice(0);
      this.messageList = [
          {
            type: 'text',
            author: 'dingHan',
            data: {
              text: '您好，欢迎来到鼎函电子保险（保函）平台，我是智能客服小鼎，有什么可以帮到您？如需人工客服请拨打400-6399580或13948539227',
              sendTime: this.getDate()
            }
          },
          {
            type: 'text',
            author: 'dingHan',
            data: {
              text: '热门提问',
              clickableText: [
                {code: 'toubao_1', name: '如何进行投保'},
                {code: 'toubao_12', name: '投保前需要准备哪些资料'},
                {code: 'toubao_10', name: '投保失败是什么原因'},
                {code: 'tuibao_1', name: '买了保证保险，可以退保吗'}
              ],
              sendTime: this.getDate()
            }
          },
          {
            type: 'text',
            author: 'dingHan',
            data: {
              text: '其他提问',
              clickableText: [
                {code: 'toubao', name: '投保相关'},
                {code: 'tuibao', name: '退保相关'},
                {code: 'lipei', name: '理赔相关'},
                {code: 'yemian', name: '页面相关'}
              ],
              sendTime: this.getDate()
            }
          },
      ];
    },
    retractChat () {
      this.isChatOpen = false
    },
    handleScrollToTop () {
      // called when the user scrolls message list to top
      // leverage pagination for loading another page of messages
    },
    handleOnType () {
      console.log('Emit typing event')
    },
    editMessage(message){
      const m = this.messageList.find(m=>m.id === message.id);
      m.isEdited = true;
      m.data.text = message.data.text;
    }
  }
};
</script>
<style  lang="scss">

</style>
<style>
.my-chart-container .sc-launcher {
  background-color: #2439a2 !important;
  box-shadow: 0 0 20px 1px rgba(0, 0, 0, 0.2);
  bottom: 80px;
}
.my-chart-container .sc-launcher img {
  padding: 12px !important;
}
.my-chart-container .sc-launcher .sc-open-icon {
  bottom: 80px;
}
.my-chart-container .sc-launcher .sc-closed-icon {
  bottom: 80px;
  width: 36px!important;
  height: 36px!important;
}
.my-chart-container .sc-chat-window {
  bottom: 10px!important;
  z-index: 9999;
  box-shadow: 0 7px 12px 14px rgba(148, 149, 150, 0.1);
}
.my-chart-container .sc-message-list {
  padding: 30px 0;
  background-color: #f8f9fb !important;
}
.my-chart-container .sc-message-list::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.my-chart-container .sc-message-list::-webkit-scrollbar-button {
  display: none;
}
.my-chart-container .sc-message-list::-webkit-scrollbar-thumb {
  background: rgba(36, 57, 162, 0.5);
  cursor: pointer;
  border-radius: 0;
}
.my-chart-container .sc-message-list::-webkit-scrollbar-corner {
  display: none;
}
.my-chart-container .sc-message-list::-webkit-resizer {
  display: none;
}
.my-chart-container .sc-message {
  padding-bottom: 30px;
}
.my-chart-container .sc-message--text {
  max-width: calc(100% - 40px) !important;
  box-shadow: 0 2px 12px 4px rgba(0, 0, 0, 0.1);
}
.my-chart-container .sc-message--content.received .sc-message--text {
  background-color: rgb(255, 255, 255) !important;
}
.my-chart-container .sc-header--close-button {
  margin-right: 0;
  margin-left: 0;
}
.my-chart-container .sc-header--close-button:hover {
  box-shadow: 0 2px 6px 4px rgba(0, 0, 0, 0.1) !important;
  background-color: #5473e8;
}
.my-chart-container .sc-user-input {
  background-color: rgb(255, 255, 255) !important;
}

</style>
